module.exports = __webpack_public_path__ + "img/rentals.a3a7ba24.svg";